var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 6.33333C4.66667 3.9401 6.60677 2 9.00001 2C11.3932 2 13.3333 3.9401 13.3333 6.33333C13.3333 8.72657 11.3932 10.6667 9.00001 10.6667C6.60677 10.6667 4.66667 8.72657 4.66667 6.33333ZM9.00001 -4.76837e-07C5.5022 -4.76837e-07 2.66667 2.83553 2.66667 6.33333C2.66667 9.83114 5.5022 12.6667 9.00001 12.6667C12.4978 12.6667 15.3333 9.83114 15.3333 6.33333C15.3333 2.83553 12.4978 -4.76837e-07 9.00001 -4.76837e-07ZM3.2692 19.2692C4.08186 18.4565 5.18406 18 6.33333 18H11.6667C12.8159 18 13.9181 18.4565 14.7308 19.2692C15.5435 20.0819 16 21.1841 16 22.3333V25C16 25.5523 16.4477 26 17 26C17.5523 26 18 25.5523 18 25V22.3333C18 20.6536 17.3327 19.0427 16.145 17.855C14.9573 16.6673 13.3464 16 11.6667 16H6.33333C4.65363 16 3.04272 16.6673 1.85499 17.855C0.66726 19.0427 0 20.6536 0 22.3333V25C0 25.5523 0.447715 26 1 26C1.55228 26 2 25.5523 2 25V22.3333C2 21.1841 2.45655 20.0819 3.2692 19.2692Z",
    fill: "#121633"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.028441f16ea5b444a2d37d5f0d30e685.svg";
export { ForwardRef as ReactComponent };